import BaseAction from "../base-action";
import {ActionTypeEnum} from "../../base/training-literals";

class GetTimeDuration extends BaseAction {
    variableName;
    initialTimeVariableName;
    endTimeVariableName;
    useCurrentTimeAsEndTime;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.GET_TIME_DURATION;
        this.variableName = props.variableName || "";
        this.initialTimeVariableName = props.initialTimeVariableName || "";
        this.endTimeVariableName = props.endTimeVariableName || "";
        this.useCurrentTimeAsEndTime = props.useCurrentTimeAsEndTime || false;
    }

    get(props = {}) {
        return {
            type: this.actionType,
            variableName: this.variableName,
            initialTimeVariableName: this.initialTimeVariableName,
            endTimeVariableName: this.endTimeVariableName,
            useCurrentTimeAsEndTime: this.useCurrentTimeAsEndTime,
            duration: props.duration || this.duration,
        };
    }
}

export default GetTimeDuration;
